'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { Box } from '@design-system/box';
import { Container } from '@design-system/container';
import { Col, Grid, GridRow } from '@design-system/grid';
import { useI18n } from '@design-system/i18n';
import { Link } from '@design-system/link';
import { useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { RelatedNewsCard } from './RelatedNewsCard';
import { useNewsShowContext } from '../context/NewsShowContext';
export const RelatedNews = () => {
    const { s__ } = useI18n();
    const theme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.outboxedFontBrightness);
    const { data: { relatedNews }, routes: { getNewsShowRoute }, } = useNewsShowContext();
    if (!relatedNews || (relatedNews === null || relatedNews === void 0 ? void 0 : relatedNews.length) === 0) {
        return null;
    }
    return (_jsx(Container, { height: "auto", pb: 15, children: _jsxs(Grid, { height: "100%", width: "100%", children: [_jsx(GridRow, { children: _jsx(Col, { offset: { xl: 2 / 12, m: 1 / 12 }, width: { xl: 4 / 12, m: 5 / 12 }, children: _jsx(ThemeProvider, { theme: updatedTheme, children: _jsx(Box, { font: "h2-semibold", lineHeight: "29px", mt: 9, children: s__('News|Other news') }) }) }) }), _jsx(GridRow, { flexWrap: { _: 'nowrap', m: 'wrap' }, children: relatedNews.map((item, index) => {
                        const { content, coverPicture, id, publishedAt, seoDescription, seoTitle, subject, } = item;
                        return (_jsx(Col, { offset: {
                                xl: index === 0 ? 2 / 12 : 0,
                                m: index === 0 ? 1 / 12 : 0,
                            }, width: { xl: 4 / 12, m: 5 / 12 }, children: _jsx(Link, { to: getNewsShowRoute(id), children: _jsx(RelatedNewsCard, { coverPicture: coverPicture, description: seoDescription || content, publishedAt: publishedAt, subject: seoTitle || subject }) }) }, id));
                    }) })] }) }));
};
//# sourceMappingURL=RelatedNews.js.map